<template>
  <section class="content-block small-padding">
    <transition name="slide-fade-delay">
      <div
        v-if="active"
        class="block has-white-background"
      >
        <div class="inner-block no-padding">
          <h1 class="title">
            {{ $t("fehlerView.label.tryReservationAgain") }}
          </h1>
          <h2 class="subtitle">
            {{ $t("fehlerView.label.tryReservationAgainHint") }}
          </h2>
          <a
            @click="reset_Fn('/')"
            class="button is-outlined is-primary"
          >{{ $t("general.button.goToHomepage") }}</a>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
    export default {
        name: 'Start',
        props: {
            msg: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                active: false
            }
        },
        mounted() {
            this.active = true
        },
        methods: {
            goToPath(route) {
                this.$router.push(route)
            },
            reset_Fn(route) {
                this.$store.state.refresh = true
                this.$router.push(route)
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
